import { NamedResourceChipComponent } from './named-resource-chip.component';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.components.named-resource-chip', [])
  .component('sfNamedResourceChip', NamedResourceChipComponent).name;
